import { Util,Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios4 } = Request;

const URL = getOrigin("www") + "/sapi/v4/market/public/";

//获取交易对配置
export function get_symbol(config) {
  return XtAxios4.get(URL + `symbol`, config);
}
//推荐交易对 首页HomeBanner
export function get_recommend_symbol(config) {
  return XtAxios4.get(URL + `recommend/symbol`, config);
}

//获取24h行情统计 首页HomeMarket
export function get_ticker24h(config) {
  return XtAxios4.get(URL + `ticker/24h`, config);
}
export function get_tradeRecent(config) {
  return XtAxios4.get(URL + `trade/recent`, config);
}
export function get_depth(config) {
  return XtAxios4.get(URL + `depth`, config);
}
export function get_time(config) {
  return XtAxios4.get(URL + `time`, config);
}
//获取排行榜配置 首页HomeMarket
export function get_topConfig(config) {
  return XtAxios4.get(URL + `top/config`, config);
}

const CFD_URL = getOrigin("www") + "/sapi/v4/cfd/public/market/";
/**
 * CFD 榜单配置（POST）
 * - 已登录：传 authLevel、fiatCurrencyIds（来自 getUserInfo），用于服务端判断是否展示 Fiat-M
 * - 未登录：传 {}
 * @param {Object} payload - {} 或 { authLevel: number, fiatCurrencyIds: string[] }
 * @param {Object} config - 请求配置（如 isAutoPopError）
 */
export function get_cfdMarketTopConfig(payload = {}, config) {
  return XtAxios4.post(CFD_URL + `top/config`, payload, config);
}
//获取K线数据 首页HomeMarket
export function get_kline(config) {
  return XtAxios4.get(URL + `kline`, config);
}
export function get_cfd_kline(config) {
  return XtAxios4.get(getOrigin("www") + "/sapi/v4/cfd/market/klines", config);
}
export function get_cfd_ticker24h(config) {
  return XtAxios4.get(getOrigin("www") + "/sapi/v4/cfd/market/ticker/24h", config);
}
export function get_cfd_symbol(config) {
  return XtAxios4.get(getOrigin("www") + "/sapi/v4/cfd/public/symbol", config);
}
//获取所有板块
export function get_plate(config) {
  return XtAxios4.get(URL + `plate`, config);
}
const EXAPIURL = getOrigin("www") + "/exapi/";
export function get_price_supported(config) {
  return XtAxios4.get(EXAPIURL + `price/public/currency/supported`, config);
}